var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("footer", { staticClass: "py-4 bg-blue text-white-50 text-left" }, [
      !_vm.region
        ? _c("div", [
            _c("img", {
              staticClass: "img-sthlm",
              attrs: {
                src: require("../assets/img/regioner/SE2321000016/footer.svg"),
                alt: "Footer för Region Stockholm"
              }
            }),
            _vm._v("\n       \n      ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.region
        ? _c("div", [
            _c("img", {
              staticClass: "img-footer",
              attrs: {
                src: require("../assets/img/regioner/" +
                  _vm.region +
                  "/footer.svg"),
                alt: "Footer för specifik region"
              }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      !_vm.region
        ? _c("p", [
            _vm._v("\n      Endokrinmottagningen Huddinge "),
            _c("br"),
            _vm._v("\n      141 86 Stockholm "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "tel:+46812380000" } }, [
              _vm._v("08-123 800 00")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n      © " + _vm._s(_vm.getCurrentYear) + " BCB Medical AB "
            ),
            _c("br")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.region === "SE2321000016"
        ? _c("p", [
            _vm._v("\n      Endokrinmottagningen Huddinge "),
            _c("br"),
            _vm._v("\n      141 86 Stockholm "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "tel:+46812380000" } }, [
              _vm._v("08-123 800 00")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n      © " + _vm._s(_vm.getCurrentYear) + " BCB Medical AB "
            ),
            _c("br")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.region === "SE162321000255"
        ? _c("p", [
            _vm._v("\n      Skånes universitetssjukhus Malmö "),
            _c("br"),
            _vm._v("\n      214 28 Malmö "),
            _c("br"),
            _vm._v(" "),
            _c("a", { attrs: { href: "tel:+4640331000" } }, [
              _vm._v("040-33 10 00")
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(
              "\n      © " + _vm._s(_vm.getCurrentYear) + " BCB Medical AB "
            ),
            _c("br")
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0959a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0959a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = null
// module chunks = 